(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-collection-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    new Splide('.splide', {
      type: 'loop',
      drag: 'free',
      focus: 'left',
      perPage: 4,
      gap: '20px',
      pagination: false,
      autoScroll: {
        speed: 1
      },
      breakpoints: {
		990: {
			perPage: 2,
		}
}
    }).mount(window.splide.Extensions);
  });


  } catch(e) { console.error(e); }
})();
})();
